import AccessRestricted from "@/components/AccessRestricted";
import Layout from "@/components/layout";
import { TeamsController } from "@/modules/teams/TeamsController";
import { useHasPermission } from "@/store/authStore";
import { Permission } from "@forgepoint/shared";

export default function Teams() {
  const canViewUsers = useHasPermission(Permission.USERS_VIEW);

  if (!canViewUsers) {
    return (
      <AccessRestricted
        breadcrumbs={[{ label: "Users", current: true }]}
        message="You don't have permission to view this page."
      />
    );
  }

  return (
    <Layout breadcrumbs={[{ label: "Users", current: true }]}>
      <TeamsController />
    </Layout>
  );
}
